import { Heading } from '@chakra-ui/react'
import React from 'react'
import ChangeRole from './ChangeRole'

const CreateAdmin = () => {

    return (
        <>
            <Heading textAlign="center" mt={5} textDecoration={"underline"}>List of All user</Heading>
            <ChangeRole />
        </>
    )
}

export default CreateAdmin
